'use client';

import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@shared/components/shadcn';
import { getSiteConfig } from '@shared/config';
import { useTranslations } from 'next-intl';
import { useKycDialog } from '../context/KycDialogContext';
import type { SkipVerificationDialogProps } from '../types';

function SkipVerificationDialog({ isOpen, onContinueVerification, onDoItLater }: SkipVerificationDialogProps) {
  const { isNameChangeFlow } = useKycDialog();
  const { isUseNameChangeManualUploadCopy } = getSiteConfig().PROFILE_INFO;
  const t = useTranslations('global_dialogs.kyc_verification.skip_verification_dialog');
  const isNameChangeCopy = isNameChangeFlow && isUseNameChangeManualUploadCopy;

  const handlePreventDefault = (e: Event) => {
    e.preventDefault();
  };

  return (
    <Dialog open={isOpen} onOpenChange={open => !open && onContinueVerification()}>
      <DialogContent
        variant="dialog"
        className="z-[1001]"
        onPointerDownOutside={handlePreventDefault}
        onEscapeKeyDown={handlePreventDefault}
        data-track-feature="Verification"
        data-track-container="Skip Verification"
        data-testid="skip-verification-dialog"
      >
        <DialogHeader>
          <DialogTitle>{t('title')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t(isNameChangeCopy ? 'name_change.description' : 'description')}</DialogDescription>
        <DialogFooter className="flex-col [&>button]:w-full sm:flex-row sm:[&>button]:w-auto" data-track-container="Actions">
          <Button variant="secondary" onClick={onContinueVerification} data-track-name="Cancel" data-testid="skip-continue-button">
            {t('continue_verification')}
          </Button>
          <Button onClick={onDoItLater} data-track-name="Confirm" data-testid="do-it-later-button">
            {t('do_it_later')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { SkipVerificationDialog };
